import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Modal, Tabs, Skeleton, message } from 'antd'
import ds from '../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch, useSelector } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import {
  loadSellAttributeLoading,
  loadSellAttributes
} from '../../appRedux/actions/Sell'
import {
  closeAttribTabsModal,
  getDecryptID,
  getRandomInt,
  loadShowAttribDrop
} from '../../appRedux/actions'
import {
  ArrowLeftOutlined,
  BackwardOutlined,
  CloseOutlined
} from '@ant-design/icons'
import SellAttribCardForTabs from './SellAttribCardForTabs'
import CardAttribSalesForTabs from './CardAttribSalesForTabs'
import { ATTRIB_MODAL_TYPES } from '../../constants/MobAppConstants'

const SellAttributeSelectTabs = props => {
  const { currency } = props
  const selOut = props.out ? props.out : false
  const selReg = props.reg ? props.reg : false
  const dispatch = useDispatch()
  const history = useHistory()
  const { TabPane } = Tabs

  const sellAttributeLoading = useSelector(
    ({ Sell }) => Sell.sellAttributeLoading
  )
  const sellAttributes = useSelector(({ Sell }) => Sell.sellAttributes)
  const sellAttributesGroups = useSelector(
    ({ Sell }) => Sell.sellAttributesGroups
  )
  const dropDownStates = useSelector(
    ({ commonConfigs }) => commonConfigs.dropDownStates
  )
  const getSelectedOutlet = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedOutlet
  )
  const mountSellAttribTabs = useSelector(
    ({ Sell }) => Sell.mountSellAttribTabs
  )
  const mountSellAttribTabs_type = useSelector(
    ({ Sell }) => Sell.mountSellAttribTabs_type
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getSelectedReg, setSelectedReg] = React.useState({})
  const [isSpecificAttrib, setIsSpecificAttrib] = React.useState(false)
  const [selAttribName, setSelAttribName] = React.useState('')
  const [selectedData, setSelectedData] = React.useState([])
  const [data, setData] = React.useState([])
  const [groupData, setGroupData] = React.useState([])
  const [activeTab, setActiveTab] = React.useState(0)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (
        sellAttributesGroups &&
        sellAttributesGroups.length &&
        sellAttributesGroups.length > 0
      ) {
        setActiveTab(getDecryptID(sellAttributesGroups[0].groupID))
      }
      if (!mountSellAttribTabs) {
        onModalClose(true)
      }
    }

    return () => {
      mounted = false
    }
  }, [mountSellAttribTabs])

  // useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     if (
  //       sellAttributes &&
  //       sellAttributes.length &&
  //       sellAttributes.length > 0
  //     ) {
  //       if (mountSellAttribTabs_type == ATTRIB_MODAL_TYPES.RETRIEVE_SALE) {
  //         let da = sellAttributes.filter(q => q.saleCount > 0)
  //         setData(da)
  //       } else if (mountSellAttribTabs_type == ATTRIB_MODAL_TYPES.PARK_SALE) {
  //         setData(sellAttributes)
  //       }
  //     } else setData([])
  //   }

  //   return () => {
  //     mounted = false
  //   }
  // }, [sellAttributes])

  function onTabChange (e) {
    setActiveTab(e)
    const tabs = sellAttributesGroups
    const data =
      tabs && tabs.length > 0
        ? tabs.filter(a => getDecryptID(a.groupID) == e)
        : []
    if (data && data.length > 0) {
      dispatch(loadSellAttributeLoading(true))
      dispatch(
        loadSellAttributes(
          {
            GroupID: data[0].groupID ? data[0].groupID : '',
            OutletID: getSelectedOutlet
          },
          isOnline
        )
      )
      // dispatch(loadIsShowSellAttribute(true))
    } else {
      message.warn('Something wrong, Kindly refresh and select again')
    }
  }

  function onModalClose (fromEffect) {
    setIsSpecificAttrib(false)
    setCardSelectedData([])
    setSelAttribName('')
    if (!fromEffect) {
      closeAttribTabsModal(dispatch, dropDownStates)
    }
    setData([])
    setGroupData([])
    setActiveTab(0)
  }

  function setCardSelectedData (data) {
    setSelectedData(data)
  }

  function setShowTabs (e) {
    if (e) {
      setIsSpecificAttrib(e)
    } else {
      setIsSpecificAttrib(false)
      setCardSelectedData([])
      setSelAttribName('')
      // setData([])
      // setGroupData([])
      // setActiveTab(0)
    }
  }

  return (
    <Modal
      className='Retrieve-Sale-modal'
      centered
      visible={mountSellAttribTabs && mountSellAttribTabs_type}
      footer={
        <>
          <Button
            size='large'
            className='dk-btn-cancel'
            onClick={() => onModalClose()}
          >
            Close
          </Button>
        </>
      }
      onCancel={() => onModalClose()}
      width={900}
      closeIcon={<Button className='Close-modal' icon={<CloseOutlined />} />}
      title={
        isSpecificAttrib ? (
          <div className='d-flex align-items-center Park-Sale-controller'>
            <Button
              className='d-flex align-items-center justify-content-center'
              type='primary'
              onClick={() => setShowTabs(false)}
              icon={<ArrowLeftOutlined />}
            >
              Back
            </Button>

            <strong> {selAttribName} </strong>
          </div>
        ) : (
          <>
            <strong>
              {mountSellAttribTabs_type == ATTRIB_MODAL_TYPES.RETRIEVE_SALE
                ? 'Retrieve Sale'
                : 'Park Sale'}
            </strong>
          </>
        )
      }
    >
      <div>
        {isSpecificAttrib ? (
          <CardAttribSalesForTabs
            data={selectedData}
            setShow={setShowTabs}
            currency={currency}
            outID={selOut}
          />
        ) : (
          <Tabs
            // activeKey={
            //   getSelectedOutlet && getSelectedOutlet.id
            //     ? getSelectedOutlet.id.substring(
            //         0,
            //         getSelectedOutlet.id.indexOf('&')
            //       )
            //     : storageOutID
            //     ? storageOutID
            //     : ''
            // }
            size='large'
            animated
            onChange={onTabChange}
            activeKey={activeTab}
          >
            {sellAttributesGroups &&
            sellAttributesGroups.length &&
            sellAttributesGroups.length > 0 ? (
              sellAttributesGroups.map((e, key) => {
                return (
                  <TabPane
                    tab={
                      <div
                      // onClick={() => onOutletClick(e)}
                      >
                        {e.title}
                      </div>
                    }
                    key={
                      e.groupID && e.groupID.includes('&')
                        ? e.groupID.substring(0, e.groupID.indexOf('&'))
                        : ''
                    }
                    style={{ fontWeight: 'bold' }}
                    forceRender
                  >
                    {sellAttributeLoading ? (
                      <Skeleton count={5} height={30} />
                    ) : (
                      <div className='outlet-cards'>
                        <Row
                          // justify="space-around"
                          gutter={10}
                          justify={
                            sellAttributes &&
                            sellAttributes.length &&
                            sellAttributes.length > 0 &&
                            sellAttributes.filter(j =>
                              mountSellAttribTabs_type ==
                              ATTRIB_MODAL_TYPES.RETRIEVE_SALE
                                ? j.saleCount > 0
                                : j
                            ).length > 0
                              ? 'start'
                              : 'center'
                          }
                        >
                          {sellAttributes &&
                          sellAttributes.length &&
                          sellAttributes.length > 0 &&
                          sellAttributes.filter(j =>
                            mountSellAttribTabs_type ==
                            ATTRIB_MODAL_TYPES.RETRIEVE_SALE
                              ? j.saleCount > 0
                              : j
                          ).length > 0 ? (
                            sellAttributes
                              .filter(j =>
                                mountSellAttribTabs_type ==
                                ATTRIB_MODAL_TYPES.RETRIEVE_SALE
                                  ? j.saleCount > 0
                                  : j
                              )
                              .sort((a, b) =>
                                a.displaySeqNo > b.displaySeqNo
                                  ? 1
                                  : b.displaySeqNo > a.displaySeqNo
                                  ? -1
                                  : 0
                              )
                              .map((d, key) => {
                                let spanWidth = 24
                                let id = d.attributeID
                                  ? d.attributeID.substring(
                                      0,
                                      d.attributeID.indexOf('&')
                                    )
                                  : ''
                                let selectedID =
                                  getSelectedReg && getSelectedReg.id
                                    ? getSelectedReg.id.substring(
                                        0,
                                        getSelectedReg.id.indexOf('&')
                                      )
                                    : 'XXX'
                                if (sellAttributes.length < 4) {
                                  spanWidth = parseInt(
                                    spanWidth / sellAttributes.length
                                  )
                                } else {
                                  spanWidth = parseInt(spanWidth / 4) // 3
                                }
                                let hourDiff = 0
                                let minDiff = 0
                                if (d && d.createdOn && d.inProgress) {
                                  const startTime = new Date(d.createdOn)
                                  const endTime = new Date()
                                  // hourDiff = endTime.getHours() - startTime.getHours()
                                  // minDiff = endTime.getMinutes() - startTime.getMinutes()
                                  const timeDifference = endTime - startTime
                                  hourDiff = Math.floor(
                                    timeDifference / (1000 * 60 * 60)
                                  )
                                  minDiff = Math.floor(
                                    (timeDifference % (1000 * 60 * 60)) /
                                      (1000 * 60)
                                  )
                                }
                                return (
                                  <Col
                                    key={key}
                                    xs={24}
                                    sm={
                                      sellAttributes.length < 4
                                        ? 24 / sellAttributes.length
                                        : 24 / 3
                                    }
                                    md={spanWidth}
                                    lg={spanWidth}
                                  >
                                    {/* <Col key={key} span={6}> */}
                                    <SellAttribCardForTabs
                                      d={d}
                                      selectedID={selectedID}
                                      id={id}
                                      hours={hourDiff}
                                      minutes={minDiff}
                                      currency={currency}
                                      keyy={key}
                                      setData={setCardSelectedData}
                                      setShow={setShowTabs}
                                      setName={setSelAttribName}
                                    />
                                  </Col>
                                )
                              })
                          ) : (
                            <div>
                              <Col span={24}>
                                <h2 className='mb-0'>
                                  {mountSellAttribTabs_type ==
                                  ATTRIB_MODAL_TYPES.RETRIEVE_SALE ? (
                                    <>{`No Parked Sales`}</>
                                  ) : (
                                    <>{`Kindly enter attributes from Sell Menu's Settings.`}</>
                                  )}
                                </h2>
                              </Col>
                            </div>
                          )}
                        </Row>
                      </div>
                    )}
                  </TabPane>
                )
              })
            ) : (
              <div style={{ marginTop: '20%', marginLeft: '12%' }}>
                <Row justify='center'>
                  <Col>
                    <h2>{'Check connection & Reload'}</h2>
                  </Col>
                </Row>
              </div>
            )}
          </Tabs>
        )}
      </div>
    </Modal>
  )
}

export default SellAttributeSelectTabs
